import React from "react";

const Onboard: React.FC = () => {
  return (
    <div className="index-container py-10 px-4 mx-8 my-2">
      <div className="index-titleWrapper text-center text-2xl font-bold mb-8">
        Open Gateway Channel Partner Onboarding
      </div>
      <div className="index-process flex items-center justify-between">
        <div className="flex flex-col items-center">
          <a href="https://partner.u.com.my/partner/#/login">
            <img
              src={`${process.env.PUBLIC_URL}/ic_icon_step1-7401a744.svg`}
              alt="Step 1"
              className="w-16 h-16 mb-2"
            />
          </a>
          <p className="text-lg font-medium">Registration</p>
          <p className="text-sm text-gray-500">Step 1</p>
        </div>
        <div className="flex-grow border-t-2 border-dotted border-orange-100 mx-4"></div>
        <div className="flex flex-col items-center">
          <img
            src={`${process.env.PUBLIC_URL}/ic_icon_step2-85f52c1e.svg`}
            alt="Step 2"
            className="w-16 h-16 mb-2"
          />
          <p className="text-lg font-medium">Approval</p>
          <p className="text-sm text-gray-500">Step 2</p>
        </div>
        <div className="flex-grow border-t-2 border-dotted border-orange-100 mx-4"></div>
        <div className="flex flex-col items-center">
          <img
            src={`${process.env.PUBLIC_URL}/ic_icon_step3-f9d9ed47.svg`}
            alt="Step 3"
            className="w-16 h-16 mb-2"
          />
          <p className="text-lg font-medium">GSMA Open Service Agreement</p>
          <p className="text-sm text-gray-500">Step 3</p>
        </div>
        <div className="flex-grow border-t-2 border-dotted border-orange-100 mx-4"></div>
        <div className="flex flex-col items-center">
          <img
            src={`${process.env.PUBLIC_URL}/ic_icon_step4-e978bc41.svg`}
            alt="Step 4"
            className="w-16 h-16 mb-2"
          />
          <p className="text-lg font-medium">Service Launch</p>
          <p className="text-sm text-gray-500">Step 4</p>
        </div>
      </div>
    </div>
  );
};

export default Onboard;
